import MainSidebar from "./MainSidebar";

export default function DesktopLayout({ children }) {
  return (
    <div className="min-h-screen w-full flex bg-(--surface-base) text-(--neutral-900)">
      <MainSidebar>
      <main className="flex-1 min-h-screen bg-(--surface-base) text-(--neutral-900)">
        {children}
      </main>
      </MainSidebar>
    </div>
  );
}